import api from './api';

export interface VideoInfo {
  videoId: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  duration: number;
  channelTitle: string;
  reflection?: string;
  embedUrl?: string;
}

export const integrationsService = {
  /**
   * Processa um vídeo do YouTube e retorna todas as informações + reflexão gerada
   */
  async processVideo(url: string): Promise<VideoInfo> {
    const response = await api.post('/integrations/process-video', { url });
    return response.data.data;
  },

  /**
   * Busca apenas informações do YouTube (sem gerar reflexão)
   */
  async getYouTubeInfo(url: string): Promise<VideoInfo> {
    const response = await api.post('/integrations/youtube/video-info', { url });
    return response.data.data;
  },

  /**
   * Gera uma reflexão usando Gemini
   */
  async generateReflection(verseText: string, bibleReference?: string): Promise<string> {
    const response = await api.post('/integrations/gemini/generate-reflection', {
      verseText,
      bibleReference,
    });
    return response.data.data.reflection;
  },
};
